'use client'

import { useEffect } from 'react'

interface HeartbeatPingerProps {
  tenantId: string | null
}

export function HeartbeatPinger({ tenantId }: HeartbeatPingerProps) {
  useEffect(() => {
    let cancelled = false

    const ping = () => {
      // Giriş ekranında henüz panel izni yoktur. Bu sıradaki anonim ping,
      // yeni açılan Auth çerezini yarışarak temizlememelidir.
      if (!tenantId) return
      if (typeof document !== 'undefined' && document.hidden) return
      fetch('/api/admin/heartbeat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-store',
        body: JSON.stringify({ tenant_id: tenantId }),
      }).catch(() => {
        // sessizce gec
      })
    }

    // Ilk ping
    ping()

    const interval = window.setInterval(() => {
      if (!cancelled) ping()
    }, 300_000)

    const onVisibility = () => {
      if (!document.hidden) ping()
    }
    document.addEventListener('visibilitychange', onVisibility)

    return () => {
      cancelled = true
      window.clearInterval(interval)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [tenantId])

  return null
}
